import { gql } from '@apollo/client';

const editProduct = gql`
  mutation editProductMutation($input: EditProductInput) {
    editProduct(input: $input) {
      id
      merchantProductId
      sku
      taxCode
      glCode
      type
      description
      status
      metadata {
        key
        value
      }
      prices {
        frequency
        currency {
          name
          symbol
        }
        amount
      }
      products {
        id
        sku
        taxCode
        glCode
        merchantProductId
        type
        status
        description
        metadata {
          key
          value
        }
        prices {
          frequency
          currency {
            name
            symbol
          }
          amount
        }
        currentVersion
        grants {
          id
          description
        }
      }
      currentVersion
      grants {
        id
        description
      }
    }
  }
`;

export default editProduct;
